import './NavigationButtons.css';

interface NavigationButtonsProps {
	currentSlide: number;
	totalSlides: number;
	onSlideChange: (index: number) => void;
}

const NavigationButtons = ({ currentSlide, totalSlides, onSlideChange }: NavigationButtonsProps) => {
	return (
		<section id="navigation-buttons">
			<button onClick={() => onSlideChange(currentSlide - 1)} disabled={currentSlide === 0} className="prev-button">
				<div className="icon icon-left" />
			</button>
			<button onClick={() => onSlideChange(currentSlide + 1)} disabled={currentSlide === totalSlides - 1} className="next-button">
				<div className="icon icon-right" />
			</button>
		</section>
	);
};

export default NavigationButtons;
